import id from './{id}';
import query from './query';
import get from './get';
import post from './post';

export type PostPayload = {
  name: string;
};
export default { id, query, get, post };
